import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { ONBOARD_CONSTANTS } from '../../app.constants';
import { GetDeviceStatusModel, GetDeviceRequestModel, GetDeviceTypeRequestModel } from './landing.model';
import { WifiActivateRequestModel } from '../travelers/travelers.model';
import { HttpService } from '../../services/http.service';
import { AppService } from '../../app.service';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@auth0/auth0-angular';
import jwt_decode from "jwt-decode";

declare let $: any;

@Injectable()
export class LandingService {
  private getdeviceResponse = {};
  private getDeviceStatus: GetDeviceStatusModel;
  private errors = {};
  private activateWifiRequest: WifiActivateRequestModel;
  public deviceName: any;
  public showhashTagUrl: any;
  configuredTailId: any;
  isA321 = false;
  accessToken:any;

  constructor(
    private cookieService: CookieService,
    private httpService: HttpService,
    private appService: AppService,
    private auth: AuthService,
    private translateService: TranslateService) {
      //this.handleRedirect();
      //console.log('landing comp');
    }

    async handleRedirect() {
      let result = this.auth.handleRedirectCallback().subscribe();
      //const isAuthenticated = this.auth.user$
      this.auth.isAuthenticated$.subscribe(async authenticated => {
        //console.log('isAuthenticated: ',authenticated);
        if(authenticated) {
          this.getAccessToken();
        };
      });
      //console.log('Result: ',result);
    }
  
    async getAccessToken() {
      try {
        // Get the access token silently
        this.auth.getAccessTokenSilently().subscribe(token => {
          //console.log('access_token subscribed: ', token);
          this.accessToken = token;
          let resultToken: any = jwt_decode(token);
          //console.log('Res Token: ', resultToken);
          const expiresAt = JSON.stringify(1000000 + new Date().getTime());
          sessionStorage.setItem('sessionId', resultToken.sessionId);
          sessionStorage.setItem('access_token', this.accessToken);
          sessionStorage.setItem('expires_At', expiresAt);
          localStorage.setItem('ebLogin', 'true');
          //this.connectToWifi();
        });
      } catch (error) {
        console.error('Error getting access token:', error);
      }
    }
  checkOnboardEnable(): boolean {
    const onboardIpFlag = this.appService.getOnboardIpFlag();
    if (onboardIpFlag && ONBOARD_CONSTANTS.ENABLE_ONBOARD === 'true') {
      return true;
    } else {
      return false;
    }
  }

  getChatUrl() {
    let chatUrl = '';
    const host = window.location.host;
    if (host.indexOf('localhost') > -1 || host.indexOf('test') > -1) {
      chatUrl = ONBOARD_CONSTANTS.CHATBOT_TESTURL;
    }
    else {
      chatUrl = ONBOARD_CONSTANTS.CHATBOT_PRODURL;
    }
    return chatUrl;
  }

  getChatRequestUrl(deviceData) {
    const request = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_FLIGHT + deviceData.flightId
    };
    return request;
  }


  getDeviceRequestEntity(deviceToken): GetDeviceRequestModel {
    const request = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_DEVICE + deviceToken
    };
    return request;
  }

  checkDeviceStatus(): GetDeviceStatusModel {
    const deviceData: any = this.getGetDeviceResponse();
    //console.log('device Data: ', deviceData);
    let deviceStatus = {};
    if (!deviceData.errors) {
      if (deviceData.status) {
        const deviceStatusCode = deviceData.status.code;
        if (deviceStatus && deviceStatusCode === 'FULL') {
          deviceStatus['wifiActivated'] = true;
        } else if (deviceStatusCode && deviceStatusCode === 'WLST') {
          deviceStatus = this.whiteListDeviceStatus(deviceData);
        }
      }
    } else {
      deviceStatus['error'] = true;
      this.errors = deviceData.errors;
    }
    this.getDeviceStatus = deviceStatus;
    return deviceStatus;
  }

  whiteListDeviceStatus(deviceData): GetDeviceStatusModel {
    const deviceStatus = {};
    const sessionId = this.appService.getSessionId();
    //console.log('session Id: ', sessionId);
    const paxStatusId = (deviceData.passenger && deviceData.passenger.status.code && deviceData.passenger.id) ? deviceData.passenger.id : 0;
    if (this.appService.getFlightServiceType()) {
      deviceStatus['gotoActivateScreen'] = true;
    } else if (paxStatusId) {
      deviceStatus['doActivateCall'] = true;
      deviceStatus['paxObjectFound'] = true;
      this.activateCallRequestUrlForPaxObj(deviceData);
    } else if (sessionId) {
      deviceStatus['doActivateCall'] = true;
      deviceStatus['paxLoggedIn'] = true;
      this.activateCallRequestUrlForLoggedIn(deviceData, sessionId);
    } else {
      deviceStatus['gotoActivateScreen'] = true;
    }
    return deviceStatus;
  }

  activateCallRequestUrlForPaxObj(deviceData) {
    const devName = this.getDeviceName();
    const wifiActivateRequestForPaxObj = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.ACTIVATE_DEVICE.replace('<<token>>', deviceData.token),
      data: {
        'flightId': deviceData.flightId,
        'deviceName': devName,
        'passenger': {
          'firstName': deviceData.passenger.firstName,
          'lastName': deviceData.passenger.lastName,
          'id': deviceData.passenger.id
        }
      }
    }
    this.activateWifiRequest = wifiActivateRequestForPaxObj;
  }

  activateCallRequestUrlForLoggedIn(deviceData, sessionIdValue) {
    const devName = this.getDeviceName();
    const wifiActivateRequestForLoggedIn = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.ACTIVATE_DEVICE.replace('<<token>>', deviceData.token),
      data: {
        'flightId': deviceData.flightId,
        'deviceName': devName,
        'passenger': {
          'sessionId': sessionIdValue
        }
      }
    }
    this.activateWifiRequest = wifiActivateRequestForLoggedIn;
  }

  activateCallRequestForVoucher(deviceData, voucherCode) {
    const devName = this.getDeviceName();
    const wifiRequestforVoucher = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.ACTIVATE_DEVICE.replace('<<token>>', deviceData.token),
      data: {
        'flightId': deviceData.flightId,
        'deviceName': devName,
        'passenger': {
          'voucherCode': voucherCode
        }
      }
    }
    this.activateWifiRequest = wifiRequestforVoucher;
    return this.activateWifiRequest;
  }
  getDeviceTypesRequest(passengerId): GetDeviceTypeRequestModel {
    const requestEntity = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_DEVICE_TYPES.replace('<<passengerId>>', passengerId)
    };
    return requestEntity;
  }

  getDisconnectWifiRequest() {
    const getDeviceData: any = this.getGetDeviceResponse();
    const deactivateWifiUrl = ONBOARD_CONSTANTS.DISCONNECT_WIFI.replace('<<token>>', getDeviceData.token);
    const requestEntity = {
      url: environment.apiBaseUrl + deactivateWifiUrl,
      data: {
        'flightId': getDeviceData.flightId
      }
    }
    return requestEntity;
  }

  hideActivateScreen() {
    $('#activateScreen').hide();
  }

  showActivateScreen() {
    $('#activateScreen').show();
  }

  // hideBuyBtn() {
  //  var hide = $('#buyBtnHide').hide();
  //   console.log("buybtnhide", hide);
  // }

  hideLandingBannerText() {
    setTimeout(function () { $('#top-home-banner .banner-inner-middle-content').hide(); }, 100);
  }

  showLandingBannerText() {
    $('#top-home-banner .banner-inner-middle-content').show();
  }

  getActivateRequest(): WifiActivateRequestModel {
    return this.activateWifiRequest;
  }

  setGetDeviceResponse(GetDeviceData) {
    this.getdeviceResponse = GetDeviceData;
  }

  getGetDeviceResponse() {
    return this.getdeviceResponse;
  }

  getErrors() {
    return this.errors;
  }

  getDefaultError(): any[] {
    const defaultError = [{ 'errorCode': ONBOARD_CONSTANTS.DEFAULT_ERROR }];
    return defaultError;
  }

  getDeviceTokenNullError(): any[] {
    const deviceTokenNullError = [{ 'errorCode': '7011055' }];
    return deviceTokenNullError;
  }

  getGetDeviceStatus() {
    let deviceStatusRes = this.checkDeviceStatus();
    //console.log('devicestatus res: ', deviceStatusRes);
    return this.getDeviceStatus || deviceStatusRes;
  }

  showViews() {
    $('#header-show, #sas-footer-wrapper, #app-onboard').show();

  }

  getDeviceStatusForBanner(deviceStatusCode) {
    let loadBanner;
    if (deviceStatusCode === 'FULL') {
      loadBanner = 'full-access';
    } else {
      const deviceResponse: any = this.getGetDeviceResponse();
      const deviceStatus = deviceResponse.status.code;
      if (deviceStatus === 'FULL') {
        loadBanner = 'full-access';
      } else {
        loadBanner = 'whitelist';
      }
    }
    return loadBanner;
  }

  loadNetflixBanner(bannerContent) {
    setTimeout(function () {
      $('#netflix-banner').html(bannerContent);
      $('#netflix-banner').fadeIn();
    }, 10);
  }

  setProfileData() {
    const basicProfileString = sessionStorage.getItem('basicProfile');
    if (basicProfileString && basicProfileString != null && (JSON.parse(basicProfileString)).currentTierCode) {
      const currentTierCode = 'profile-' + (JSON.parse(basicProfileString).currentTierCode).toLowerCase();
      $('#landing-terms-user-profile').attr('class', 'icon-profile profile');
      $('#user-profile, #landing-terms-user-profile').addClass(currentTierCode);
    }
    if (basicProfileString && basicProfileString != null) {
      const basicProfile = JSON.parse(basicProfileString);
      const shortName = basicProfile.firstName[0] + basicProfile.lastName[0];
      $('#user-short-name, #landing-terms-short-name').text(shortName);
      $('#user-short-name, #landing-terms-short-name').parent().parent().addClass('logged-user');
    }
  }

  setDeviceName(device) {
    const deviceInfo = device.getDeviceInfo();
    if (device.isDesktop()) {
      this.deviceName = 'Desktop - ' + deviceInfo.os;
    } else if (device.isMobile()) {
      this.deviceName = 'Mobile - ' + deviceInfo.os;
    } else if (device.isTablet()) {
      this.deviceName = 'Tablet - ' + deviceInfo.os;
    } else {
      this.deviceName = 'Unknown device';
    }

  }

  getDeviceName() {
    return this.deviceName;
  }

  setChatBotHide() {
    $(document).trigger('onboardBotHide');
  }

  setFinalDestinationDataToSession(activateResponse) {
    const wifiDestination = activateResponse.passenger.offPointFinal;
    sessionStorage.setItem('wifidestination', wifiDestination);
    sessionStorage.setItem('setWifidestination', 'true');
    this.getNetFlixBanner(activateResponse.status.code);
  }

  getNetFlixBanner(deviceStatusCode) {
    let loadBanner;
    const flightResponse = this.appService.getFlightResponse();
    this.isA321 = this.identifyIfA321(flightResponse.vehicleId);
    if(this.isA321) {
      loadBanner = this.translateService.instant('a321.bannerid');
    }
    else {
      loadBanner = this.getDeviceStatusForBanner(deviceStatusCode);
    }
    const pos = this.appService.getPOS();
    const lang = this.appService.getLanguage();
    const netflixBannerUrl = `/content/flysas-${pos}/${lang}/tx-ui/${loadBanner}/jcr:content/bannerPar.html`;
    const netflixBannerSession = sessionStorage.getItem(`NetFlixBanner_${loadBanner}_${pos}-${lang}`);
    if (netflixBannerSession) {
      this.loadNetflixBanner(netflixBannerSession);
    } else {
      this.httpService.getHtml(netflixBannerUrl).subscribe(netflixBannerData => {
        sessionStorage.setItem(`NetFlixBanner_${loadBanner}_${pos}-${lang}`, netflixBannerData);
        this.loadNetflixBanner(netflixBannerData);
      });
    }
  }

  identifyIfA321(vehicleId) {
    this.configuredTailId = this.translateService.instant('a321.tailid');
    const configuredTailIdAfterSplit = this.configuredTailId.split(',');
    return Boolean(configuredTailIdAfterSplit.indexOf(vehicleId) > -1)
  }

}
